import clsx from "clsx";
import { Button, InputText } from "shared-components";

import type { ReportOption } from ".";

import type { JSX } from "react";

interface Props {
  showDetailsInMobile: boolean;
  setShowDetailsInMobile: (val: boolean) => void;
  selectedOption: ReportOption | null;
  selectOption: (val: ReportOption | null) => void;
  details: string;
  setDetails: (val: string) => void;
  loading: boolean;
  onSubmit: () => void;
}

const reasons = [
  "Violação de direito autoral",
  "Propagação de discurso de ódio e mensagem ofensiva",
  "Nudez ou atividade sexual",
  "Violências ou organizações perigosas",
  "Outro motivo",
];

export const ReportSettings = ({
  showDetailsInMobile,
  setShowDetailsInMobile,
  selectedOption,
  selectOption,
  details,
  setDetails,
  loading,
  onSubmit,
}: Props): JSX.Element => {
  const options = reasons.map((label, index) => ({ id: index + 1, label }));

  return (
    <div>
      <h2>Por que você está denunciando esse produto?</h2>

      <p className="mt-2">Sua denúncia é anônima. Agradecemos desde já sua colaboração.</p>

      <div
        className={clsx(
          "mini-scrollbar mt-3 flex max-h-[40vh] flex-col gap-2 overflow-y-auto",
          "pr-1 lg:max-h-[28vh]",
          { "max-lg:hidden": showDetailsInMobile },
        )}
      >
        {options.map((option) => (
          <button
            key={option.id}
            onClick={() => selectOption(option)}
            className={clsx(
              "rounded-lg border-2 p-2 text-start font-bold",
              option.id === selectedOption?.id ? "border-brand-accent text-brand-accent" : "border-base-input",
              loading ? "opacity-50" : "focus-visible:border-base-black",
            )}
            disabled={loading}
          >
            {option.label}
          </button>
        ))}
      </div>

      {showDetailsInMobile && (
        <div
          className={
            "mt-3 rounded-lg border-2 border-brand-accent p-2 text-start font-bold text-brand-accent lg:hidden"
          }
        >
          {selectedOption?.label}
        </div>
      )}

      {selectedOption && (
        <div
          className={clsx("flex flex-col", {
            "max-lg:hidden": !showDetailsInMobile,
          })}
        >
          <InputText
            type="textarea"
            field="details"
            label="Nos conte mais detalhes"
            placeholder="Escreva aqui"
            className="mt-3 lg:mt-5 lg:*:max-h-8 lg:*:*:min-h-fit"
            value={details}
            onChange={(e) => setDetails(e.target.value.slice(0, 100))}
            disabled={loading}
          />

          <p className="text-details ml-auto mt-0.5 text-neutral-text">{details.length}/100</p>
        </div>
      )}

      <div className="mt-5 flex flex-col items-center *:max-w-[20.5rem]">
        <Button
          className={clsx({
            "max-lg:hidden": !showDetailsInMobile,
          })}
          onClick={onSubmit}
          disabled={!selectedOption}
          loading={loading}
        >
          Enviar denúncia
        </Button>

        {showDetailsInMobile ? (
          <Button
            color="secondary"
            className="mt-2 text-brand-accent lg:hidden"
            onClick={() => setShowDetailsInMobile(false)}
          >
            Voltar
          </Button>
        ) : (
          <Button
            className="mt-5 max-w-[20.5rem] lg:hidden"
            onClick={() => setShowDetailsInMobile(true)}
            disabled={!selectedOption}
          >
            Continuar
          </Button>
        )}
      </div>
    </div>
  );
};
